import { render } from "./OrderDetailsDetailsCol.vue?vue&type=template&id=89866928"
import script from "./OrderDetailsDetailsCol.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDetailsCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__